import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
import { HttpResponse } from "@smithy/protocol-http";
import { parseRfc7231DateTime } from "@smithy/smithy-client";
export var s3ExpiresMiddleware = function s3ExpiresMiddleware(config) {
  return function (next, context) {
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args) {
        var result, response, _context$logger;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return next(args);
              case 2:
                result = _context.sent;
                response = result.response;
                if (HttpResponse.isInstance(response)) {
                  if (response.headers.expires) {
                    response.headers.expiresstring = response.headers.expires;
                    try {
                      parseRfc7231DateTime(response.headers.expires);
                    } catch (e) {
                      (_context$logger = context.logger) === null || _context$logger === void 0 ? void 0 : _context$logger.warn("AWS SDK Warning for ".concat(context.clientName, "::").concat(context.commandName, " response parsing (").concat(response.headers.expires, "): ").concat(e));
                      delete response.headers.expires;
                    }
                  }
                }
                return _context.abrupt("return", result);
              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  };
};
export var s3ExpiresMiddlewareOptions = {
  tags: ["S3"],
  name: "s3ExpiresMiddleware",
  override: true,
  relation: "after",
  toMiddleware: "deserializerMiddleware"
};
export var getS3ExpiresMiddlewarePlugin = function getS3ExpiresMiddlewarePlugin(clientConfig) {
  return {
    applyToStack: function applyToStack(clientStack) {
      clientStack.addRelativeTo(s3ExpiresMiddleware(clientConfig), s3ExpiresMiddlewareOptions);
    }
  };
};